<template>
  <div class="overlay" @click.self="$emit('fechar')">
    <div class="modal-filtros">
      <div class="modal-header">
        <span class="modal-label">Filtros Vagas</span>
        <button class="btn-fechar-modal" @click="$emit('fechar')">
          ×
        </button>
      </div>

      <div class="modal-corpo">
        <div class="coluna">
          <p class="coluna-titulo">Data Inicial:</p>
          <input type="date" v-model="filtros.dataInicial" class="input-data" />
        </div>

        <div class="coluna">
          <p class="coluna-titulo">Data Final:</p>
          <input type="date" v-model="filtros.dataFinal" class="input-data" />
        </div>

        <div class="coluna">
          <p class="coluna-titulo">Unidade da UFC:</p>
          <select v-model="filtros.unidadeId" class="select-filtro" :class="{
            selecionado:
              filtros.unidadeId !== null && filtros.unidadeId !== '',
          }">
            <option :value="null">Todas as unidades</option>
            <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">
              {{ unidade.nome.toUpperCase() }}
            </option>
          </select>
        </div>

        <div class="coluna">
          <p class="coluna-titulo">Status da vaga:</p>
          <select v-model="filtros.status" class="select-filtro" :class="{
            selecionado: filtros.status !== '' && filtros.status !== null,
          }">
            <option :value="''">Todos os status</option>
            <option value="ABERTA">Inscrições Abertas (ABERTA)</option>
            <option value="ENCERRADA">Inscrições Encerradas (ENCERRADA)</option>
            <option value="CANCELADA">Vaga Cancelada (CANCELADA)</option>
          </select>
        </div>

        <div class="coluna">
          <p class="coluna-titulo">Tipo da vaga:</p>
          <select v-model="tipoVagaSelecionado" class="select-filtro" :class="{
            selecionado:
              tipoVagaSelecionado !== '' && tipoVagaSelecionado !== null,
          }">
            <option value="">Todos os tipos</option>
            <option value="VOLUNTARIA">Agente</option>
            <option value="REMUNERADA">Remunerada</option>
            <option value="ESTAGIO">Estágio</option>
          </select>
        </div>

        <div class="coluna">
          <p class="coluna-titulo">Ações:</p>
          <select v-model="filtros.isCurricularizada" class="select-filtro" :class="{
            selecionado:
              filtros.isCurricularizada !== '' &&
              filtros.isCurricularizada !== null,
          }">
            <option :value="''">Todas as ações</option>
            <option :value="true">Curricularizadas</option>
            <option :value="false">Não Curricularizadas</option>
          </select>
        </div>
      </div>

      <div class="modal-rodape">
        <button class="btn-limpar" @click="limparFiltros">
          Limpar filtros
        </button>
        <button class="btn-filtrar" @click="aplicarFiltros">
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import unidadesService from "@/service/unidadesService";
import { formatarEnum } from "@/utils/FormatarEntradas";

const props = defineProps({
  filtrosIniciais: {
    type: Object,
    default: () => ({
      dataInicial: "",
      dataFinal: "",
      status: "",
      isBolsistaRemunerado: "",
      isCurricularizada: "",
      isEstagiario: "",
      unidadeId: null,
    }),
  },
});

const emit = defineEmits(["fechar", "aplicarFiltros"]);

function obterTipoInicial() {
  const isEst =
    props.filtrosIniciais?.isEstagiario === true ||
    props.filtrosIniciais?.isEstagiario === "true" ||
    props.filtrosIniciais?.estagiario === true ||
    props.filtrosIniciais?.estagiario === "true";
  if (isEst) return "ESTAGIO";

  const isRem =
    props.filtrosIniciais?.isBolsistaRemunerado === true ||
    props.filtrosIniciais?.isBolsistaRemunerado === "true" ||
    props.filtrosIniciais?.bolsistaRemunerado === true ||
    props.filtrosIniciais?.bolsistaRemunerado === "true";
  if (isRem) return "REMUNERADA";

  const isVol =
    (props.filtrosIniciais?.isBolsistaRemunerado === false ||
      props.filtrosIniciais?.isBolsistaRemunerado === "false") &&
    (props.filtrosIniciais?.isEstagiario === false ||
      props.filtrosIniciais?.isEstagiario === "false");
  if (isVol) return "VOLUNTARIA";

  return "";
}

const tipoVagaSelecionado = ref(obterTipoInicial());

const unidades = ref([]);
const filtros = ref({
  dataInicial: props.filtrosIniciais?.dataInicial || "",
  dataFinal: props.filtrosIniciais?.dataFinal || "",
  status: props.filtrosIniciais?.status || "",
  isCurricularizada:
    props.filtrosIniciais?.isCurricularizada !== undefined
      ? props.filtrosIniciais.isCurricularizada
      : "",
  unidadeId: props.filtrosIniciais?.unidadeId || null,
});

onMounted(async () => {
  try {
    const lista = await unidadesService.getAllUnidades(0, 1000);
    if (lista && Array.isArray(lista)) {
      unidades.value = lista;
    }
  } catch (e) {
    console.error("Erro ao carregar unidades em FiltrosVagas:", e);
  }
});

function extrairFiltroTipo(tipo) {
  if (tipo === "VOLUNTARIA") {
    return { isBolsistaRemunerado: false, isEstagiario: false };
  }
  if (tipo === "REMUNERADA") {
    return { isBolsistaRemunerado: true, isEstagiario: false };
  }
  if (tipo === "ESTAGIO") {
    return { isBolsistaRemunerado: false, isEstagiario: true };
  }
  return { isBolsistaRemunerado: "", isEstagiario: "" };
}

function limparFiltros() {
  tipoVagaSelecionado.value = "";
  filtros.value = {
    dataInicial: "",
    dataFinal: "",
    status: "",
    isCurricularizada: "",
    unidadeId: null,
  };
  emit("aplicarFiltros", {
    ...filtros.value,
    isBolsistaRemunerado: "",
    isEstagiario: "",
  });
  emit("fechar");
}

function aplicarFiltros() {
  const tipoFiltro = extrairFiltroTipo(tipoVagaSelecionado.value);
  emit("aplicarFiltros", { ...filtros.value, ...tipoFiltro });
  emit("fechar");
}
</script>

<style scoped>
.modal-filtros {
  width: 420px;
}


.modal-corpo {
  display: flex;
  flex-direction: column;
  background: var(--branco);
  gap: 8px;
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--preto);
  margin: 0;
}

.input-data,
.select-filtro {
  padding: 10px 12px;
  border: 1px solid var(--cinza-medio);
  border-radius: 8px;
  font-size: 0.9rem;
  outline: none;
  width: 100%;
  background: var(--branco);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.select-filtro {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.input-data:focus,
.select-filtro:focus {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 46%, 46%, 0.15);
}


.btn-limpar {
  border: 2px solid var(--roxo-medio);
  background: var(--branco);
  color: var(--roxo-medio);
  border-radius: 10px;
  padding: 8px 24px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-limpar:hover {
  background: var(--roxo-superficie);
}

.btn-filtrar {
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 24px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-filtrar:hover {
  background: var(--roxo-medio);
}

.select-filtro.selecionado {
  border-color: var(--roxo-primario) !important;
  background-color: var(--roxo-superficie) !important;
  color: var(--roxo-primario) !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 3px hsla(258, 53%, 28%, 0.08) !important;
}
</style>
